<template>
	<q-action-sheet
		v-model="isVisible"
		:title="actionSheetTitle"
		:actions="actionSheetActions"
	/>
</template>

<script lang="ts">
import { Prop, Component, Vue, Watch } from 'vue-property-decorator';
import { CourseEntry } from '@/models';
import LearningEntry from '@/models/LearningEntry';
import { mapActions } from 'vuex';

@Component({
	methods: mapActions('wmct', [
		'removeLearning',
		'editLearning',
	]),
})
export default class ListActions extends Vue {
	@Prop() public visible!: boolean;
	@Prop() public value!: LearningEntry;
	@Prop() public entityType!: string;

	private removeLearning!: ({ learning }: { learning: LearningEntry }) => Promise<void>;
	private editLearning!: ({ learning }: { learning: LearningEntry }) => Promise<void>;

	private isVisible: boolean = false;

	@Watch('isVisible')
	public onIsVisibleChange(val: boolean) {
		this.$emit('update:visible', val);
	}

	@Watch('visible')
	public onVisibleChange(val: boolean) {
		this.isVisible = val;
	}

	private get actionSheetTitle() {
		if (this.value) {
			return this.value.course.label;
		}

		return 'Course';
	}

	private async delete() {
		const self: any = this;
		const $q = self.$q;

		try {
			await $q.dialog({
				title: `Delete ${this.entityType}`,
				message: `Are you sure you want to remove this ${this.entityType}?`,
				color: 'secondary',
				ok: true,
				cancel: true,
			});
			const course = this.value;

			await this.removeLearning({ learning: course });
		} catch (err) {
			// User dismissed dialog
		}
	}

	private async edit() {
		const course = this.value;

		await this.editLearning({ learning: course });
	}

	private get actionSheetActions() {
		return [
			{
				label: 'Edit',
				icon: 'edit',
				color: 'secondary',
				handler: () => this.edit(),
			},
			{
				label: 'Delete',
				icon: 'delete',
				color: 'negative',
				handler: () => this.delete(),
			},
		];
	}

}
</script>
